import { TrendingUpRounded } from '@material-ui/icons';
import {
    INIT,
    RESET,
    SET_DIAS,
    SET_DISABLED,
    SET_TIPO_GESTION,
   
} from './types';

export const initialStateDisabled={
    "siniestro":{disabled:false, radio:true},
    "patenteAS": {disabled:false, radio:true},
    "patenteImp": {disabled:false, radio:true},
    "idcaso": {disabled:false, radio:true},
    "fechadesde": {disabled:false, radio:false},
    "fechahasta": {disabled:false, radio:false}, 
    "tipofecha": {disabled:false, radio:false}, 
    "diasVencimiento": {disabled:false, radio:true},
    "dias": {disabled:true, radio:false}, 
}

export default function buscarReducer(state , action) {
    switch (action.type) {
        case RESET:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patenteAS:{...state.patenteAS, disabled:false},
                patenteImp:{...state.patenteImp, disabled:false},
                idcaso:{...state.idcaso, disabled:false},
                fechadesde:{...state.fechadesde, disabled:false},
                fechahasta:{...state.fechahasta, disabled:false},
                tipofecha:{...state.tipofecha, disabled:false},
                diasVencimiento:{...state.diasVencimiento, disabled:false},
                dias:{...state.dias, disabled:false},   
            }
        case INIT:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patenteAS:{...state.patenteAS, disabled:false},
                patenteImp:{...state.patenteImp, disabled:false},
                idcaso:{...state.idcaso, disabled:false},
                fechadesde:{...state.fechadesde, disabled:true},
                fechahasta:{...state.fechahasta, disabled:true},
                tipofecha:{...state.tipofecha, disabled:true},
                diasVencimiento:{...state.diasVencimiento, disabled:false},
                dias:{...state.dias, disabled:false},              
            }
        case SET_DISABLED:
            action.payload.name

            return { ...state,[action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]} }
        
         case SET_TIPO_GESTION:
             return { ...state, [action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]},}
        case SET_DIAS:
            return { ...state, dias:{...state.dias, disabled:action.payload}}

        default:
            return state
    }
}